import React, { FC } from 'react';
import { FooterBeacon } from '@trp-ii-ii-component-library/ii-components';

/**
 * The App's footer.
 *
 * @constructor
 */
const Footer: FC = () => {
  return (
    <div>
      <FooterBeacon
        isLoading={false}
        productTypes={[]} /* TODO: include productTypes later or footer will not display content as expected */
        isMobileParam={false}
      />
    </div>
  );
};

export default Footer;
